// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = module.exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body .MuiToolbar-root {\r\n  padding: 0;\r\n  /* margin-top: -60px; */\r\n}\r\n.MuiButton-label {\r\n  width: 100%;\r\n  display: inherit;\r\n  align-items: inherit;\r\n  justify-content: inherit;\r\n  font-size: smaller;\r\n}\r\n", ""]);
